{
  "id": "campaign-016",
  "name": "Hidden Lawn",
  "seed": "campaign:16",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    ".....#..#.,.",
    ".........,,,",
    ".......T..,.",
    "............",
    ".#..........",
    "............",
    "...#........",
    "____________",
    ",...........",
    ",,..........",
    ",...........",
    ".....#......",
    "..~.~..#....",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "rare",
      "x": 4,
      "y": 8
    },
    {
      "kind": "repair",
      "x": 2,
      "y": 4
    }
  ],
  "generatorVersion": 3,
  "level": 16,
  "biome": "backyard",
  "par": {
    "reel": 6714,
    "push": 5276,
    "selfPropelled": 4938,
    "tractor": 4165,
    "zeroTurn": 3420,
    "fairway": 1994
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 20,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 8
    }
  }
}
